import { LaunchReportingPermissionSet, PermissionSetType, SidebarProductVisibilityPermissionSet } from '../sets'
import { AdminMinimalRole } from './AdminMinimalRole'

export const AccessToLaunchReportsRole: PermissionSetType[] = [
  ...AdminMinimalRole,
  SidebarProductVisibilityPermissionSet.ShowAnalyzeProduct,
  SidebarProductVisibilityPermissionSet.ShowAnalyticsProduct,
  LaunchReportingPermissionSet.View,
  LaunchReportingPermissionSet.Write,
  LaunchReportingPermissionSet.Delete,
  LaunchReportingPermissionSet.Export,
  LaunchReportingPermissionSet.CustomExport,
]
